export class HuobiSubDepositAddress {
  code: number;
  message: string;
  id: number;
  currency: string;
  txHash: string;
  chain: string;
  amount: number;
  address: string;
  addressTag: string;
  state: string;
  createTime: number;
  updateTime: number;
  nextId: number;
}
